/**
 * Stringify an object and convert all typed arrays to arrays
 * @param object
 * @param replacer
 * @param space
 * @returns
 */
export function stringify(object, replacer, space) {
    const internalReplacer = (key, value) => {
        if (ArrayBuffer.isView(value)) {
            value = Array.from(value);
        }
        if (replacer) {
            return replacer(key, value);
        }
        return value;
    };
    return JSON.stringify(object, internalReplacer, space);
}
//# sourceMappingURL=stringify.js.map